/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_CoverInputs */

const cs_blog_cover = /** @type {(inputs: Blog_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úvodní obrázek`)
};

const en_blog_cover = /** @type {(inputs: Blog_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover image`)
};

/**
* | output |
* | --- |
* | "Cover image" |
*
* @param {Blog_CoverInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_cover = /** @type {((inputs?: Blog_CoverInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_CoverInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_cover(inputs)
	return cs_blog_cover(inputs)
});